const strings = {
  NEW_USER: 'Ny användare',
  NEW_USER_INFORMATION:
    'Fyll i informationen nedan för att skapa en ny användare.',
  APARTMENT_NUMBER: 'Lägenhetsnummer',
  EMAIL: 'Email',
  PASSWORD: 'Lösenord',
  JANITOR: 'Vaktmästare',
  ADMIN: 'Administratör',
  CANCEL: 'Avbryt',
  CREATE: 'Skapa',
  MISSING_FIELDS_HEADER: 'Fält saknas',
  MISSING_FIELDS: 'Var god fyll i samtliga fält och försök igen.',
  OK: 'Okej',
  NOT_VALID_EMAIL: 'Emailadressen är inte giltlig',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  USER_CREATED: 'Användaren har skapats',
  EMAIL_IN_USE: 'Emailadressen är redan i bruk',
  APARTMENT_IN_USE: 'Lägenhetsnumret är redan i bruk',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/NewUserModal/strings.js